import { useEffect, useState } from 'react';
import { from } from 'rxjs';
import api from '../../api';

export default function useContextForm(context) {
    const [view, setView] = useState(undefined);

    useEffect(() => {
        const subscription = from(
            api.get('forms/context', {
                params: context,
            }),
        ).subscribe({
            next: ({ data }) => setView(data || null),
            error: (error) => {
                console.error(`Error fetching form context for ${JSON.stringify(context)}: ${error.message}`);
                setView(null);
            },
        });

        return () => subscription.unsubscribe();
        // eslint-disable-next-line
    }, []);
    
    return view;
}